import { render } from "./PlatMerchantList.vue?vue&type=template&id=666b81f8&scoped=true"
import script from "./PlatMerchantList.vue?vue&type=script&lang=js"
export * from "./PlatMerchantList.vue?vue&type=script&lang=js"

import "./PlatMerchantList.vue?vue&type=style&index=0&id=666b81f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b81f8"],['__file',"src/views/h5/common/plat/merchant/PlatMerchantList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "666b81f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('666b81f8', __exports__)) {
    api.reload('666b81f8', __exports__)
  }
  
  module.hot.accept("./PlatMerchantList.vue?vue&type=template&id=666b81f8&scoped=true", () => {
    api.rerender('666b81f8', render)
  })

}


export default __exports__